<template>
  <div class="text-center exclusive-bar" v-bind:style="[showExcStyle]">
    <span style="font-size: 18px;">
      <div class="customcheckbox mr-15 pointer" style="text-transform: unset;">
        <input type="checkbox" name="giftwrap" id="giftwrap" @click="addExclusiveToCartFromBand(EXCLUSIVE_PRODUCTS[2].prod_id)" :checked="checkedExcBox">
        <label for="" class="mb0">{{excBannerMsg}}</label>
      </div>
    </span>
    </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  var $ = require('jquery')
  window.jQuery = $

  export default {
    data () {
      return {
      }
    },
    props: ['showExcStyle', 'excBannerMsg', 'checkedExcBox'],
    mounted () {
    },
    methods: {
      addExclusiveToCartFromBand (id) {
        this.$emit('addExc', id)
      }
    },
    created () {
    },
    computed: {
      ...mapGetters({site_config: 'site_config'}),
      EXCLUSIVE_PRODUCTS: function () {
        return this.site_config.exclusive_products
      }
    },
    beforeDestroy () {
    }
  }
</script>

<style lang="css" scoped>
.banner-placeholder-row {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// ExcBand.vue?789ecea8